import React, { useEffect, useState } from "react";
import axios from "../../api/axios";
import PermissionGuard from "../../components/auth/PermissionGuard";

export default function RolesPage() {
  const [roles, setRoles] = useState([]);
  const [permissions, setPermissions] = useState({});
  const [menus, setMenus] = useState([]);
  const [selectedRoleId, setSelectedRoleId] = useState("");
  const [selectedPermissionIds, setSelectedPermissionIds] = useState([]);
  const [selectedMenuIds, setSelectedMenuIds] = useState([]);
  const [form, setForm] = useState({
    code: "",
    name: "",
    description: "",
    is_system: false,
    is_active: true,
  });

  async function loadData() {
    const [rolesRes, permissionsRes, menusRes] = await Promise.all([
      axios.get("/admin/roles"),
      axios.get("/admin/permissions"),
      axios.get("/admin/menus"),
    ]);

    setRoles(rolesRes.data?.data || []);
    setPermissions(permissionsRes.data?.data || {});
    setMenus(menusRes.data?.data || []);
  }

  useEffect(() => {
    loadData();
  }, []);

  async function loadRoleDetails(roleId) {
    if (!roleId) return;
    const res = await axios.get(`/admin/roles/${roleId}`);
    const role = res.data?.data;

    setSelectedPermissionIds((role.permissions || []).map((p) => p.id));
    setSelectedMenuIds((role.menus || []).map((m) => m.id));
  }

  async function handleCreateRole(e) {
    e.preventDefault();
    await axios.post("/admin/roles", form);
    setForm({
      code: "",
      name: "",
      description: "",
      is_system: false,
      is_active: true,
    });
    await loadData();
  }

  async function savePermissions() {
    if (!selectedRoleId) return;
    await axios.post(`/admin/roles/${selectedRoleId}/permissions`, {
      permission_ids: selectedPermissionIds,
    });
    alert("Permissions updated.");
  }

  async function saveMenus() {
    if (!selectedRoleId) return;
    await axios.post(`/admin/roles/${selectedRoleId}/menus`, {
      menu_ids: selectedMenuIds,
    });
    alert("Menus updated.");
  }

  return (
    <PermissionGuard permission="security.roles.view">
      <div>
        <h2>Roles</h2>

        <form
          onSubmit={handleCreateRole}
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
            gap: 12,
            background: "#fff",
            padding: 16,
            borderRadius: 12,
            marginBottom: 24,
          }}
        >
          <input
            placeholder="Role Code"
            value={form.code}
            onChange={(e) => setForm((prev) => ({ ...prev, code: e.target.value }))}
          />
          <input
            placeholder="Role Name"
            value={form.name}
            onChange={(e) => setForm((prev) => ({ ...prev, name: e.target.value }))}
          />
          <input
            placeholder="Description"
            value={form.description}
            onChange={(e) => setForm((prev) => ({ ...prev, description: e.target.value }))}
          />
          <button type="submit">Create Role</button>
        </form>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
          <div style={{ background: "#fff", padding: 16, borderRadius: 12 }}>
            <h3>Select Role</h3>
            <select
              value={selectedRoleId}
              onChange={async (e) => {
                const value = e.target.value;
                setSelectedRoleId(value);
                await loadRoleDetails(value);
              }}
              style={{ width: "100%", marginBottom: 16 }}
            >
              <option value="">Select role</option>
              {roles.map((role) => (
                <option key={role.id} value={role.id}>
                  {role.name}
                </option>
              ))}
            </select>

            <h4>Permissions</h4>
            <div
              style={{ maxHeight: 420, overflow: "auto", border: "1px solid #ddd", padding: 12 }}
            >
              {Object.entries(permissions).map(([module, items]) => (
                <div key={module} style={{ marginBottom: 16 }}>
                  <strong>{module}</strong>
                  <div>
                    {items.map((permission) => (
                      <label key={permission.id} style={{ display: "block", marginTop: 6 }}>
                        <input
                          type="checkbox"
                          checked={selectedPermissionIds.includes(permission.id)}
                          onChange={(e) => {
                            setSelectedPermissionIds((prev) =>
                              e.target.checked
                                ? [...prev, permission.id]
                                : prev.filter((id) => id !== permission.id)
                            );
                          }}
                        />{" "}
                        {permission.name} ({permission.code})
                      </label>
                    ))}
                  </div>
                </div>
              ))}
            </div>
            <button onClick={savePermissions} style={{ marginTop: 12 }}>
              Save Permissions
            </button>
          </div>

          <div style={{ background: "#fff", padding: 16, borderRadius: 12 }}>
            <h4>Menus</h4>
            <div
              style={{ maxHeight: 420, overflow: "auto", border: "1px solid #ddd", padding: 12 }}
            >
              {menus.map((menu) => (
                <label key={menu.id} style={{ display: "block", marginTop: 6 }}>
                  <input
                    type="checkbox"
                    checked={selectedMenuIds.includes(menu.id)}
                    onChange={(e) => {
                      setSelectedMenuIds((prev) =>
                        e.target.checked ? [...prev, menu.id] : prev.filter((id) => id !== menu.id)
                      );
                    }}
                  />{" "}
                  {menu.name} ({menu.code})
                </label>
              ))}
            </div>
            <button onClick={saveMenus} style={{ marginTop: 12 }}>
              Save Menus
            </button>
          </div>
        </div>
      </div>
    </PermissionGuard>
  );
}
